import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// React
import React, { useState } from 'react';

// MUI
import { Box, Button, Checkbox, Dialog, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, IconButton, Link, Typography } from '@mui/material';
import CheckBoxOutlineBlankSharpIcon from '@mui/icons-material/CheckBoxOutlineBlankSharp';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import CloseIcon from '@mui/icons-material/Close';

// Interfaces

// Libs
import i18n from '../i18n';
export var PrivacySettings = function PrivacySettings(props) {
  var _useState = useState(props.cookies.marketing),
    _useState2 = _slicedToArray(_useState, 2),
    marketingCookiesConsent = _useState2[0],
    setMarketingCookiesConsent = _useState2[1];
  var handleMarketingCookiesConsentChange = function handleMarketingCookiesConsentChange(event) {
    setMarketingCookiesConsent(event.target.checked);
  };
  var handleConsent = function handleConsent() {
    props.handlePrivacySettingsDialogAction(marketingCookiesConsent);
  };
  var closePrivacySettingsDialog = function closePrivacySettingsDialog() {
    props.closePrivacySettingsDialog();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, {
    disableEscapeKeyDown: true,
    TransitionProps: {
      onExited: props.exitHandler
    },
    open: props.open,
    PaperProps: {
      square: true
    },
    sx: {
      backdropFilter: 'blur(2px)',
      zIndex: 10000,
      '& .MuiDialog-paper': {
        paddingTop: '24px',
        paddingLeft: {
          lg: '24px',
          xl: '24px',
          md: '24px',
          sm: '16px',
          xs: '0'
        },
        paddingRight: {
          lg: '24px',
          xl: '24px',
          md: '24px',
          sm: '16px',
          xs: '0'
        },
        paddingBottom: '16px',
        maxWidth: '44rem',
        margin: {
          md: '32px',
          lg: '32px',
          xl: '32px',
          sm: '32px',
          xs: '0px'
        }
      }
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    sx: {
      paddingTop: '8px',
      paddingBottom: '24px'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    disableRipple: true,
    disableFocusRipple: true,
    disableTouchRipple: true,
    onClick: props.showOnlyPrivacySettingsDialog ? closePrivacySettingsDialog : function () {
      return props.handlePrivacySettingsDialogAction(false);
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12,
    lg: 12,
    md: 12,
    xl: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    sx: {
      fontSize: '1.5rem',
      fontWeight: 'normal',
      color: 'primary.main'
    }
  }, i18n.t('PRIVACY_SETTINGS_DIALOG.TITLE'))))), /*#__PURE__*/React.createElement(DialogContent, {
    sx: {
      overflowY: 'visible'
    }
  }, /*#__PURE__*/React.createElement(DialogContentText, {
    component: 'div'
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mb: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    sx: {
      color: 'info.main',
      fontSize: '1rem',
      fontWeight: 700
    }
  }, i18n.t('PRIVACY_SETTINGS_DIALOG.DISABLE_COOKIES_TITLE')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    sx: {
      color: 'info.main',
      fontSize: '1rem',
      fontWeight: 'normal'
    }
  }, i18n.t('PRIVACY_SETTINGS_DIALOG.DISABLE_COOKIES_DESCRIPTION'))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    sx: {
      color: 'info.main',
      fontSize: '1rem',
      fontWeight: 700
    }
  }, i18n.t('PRIVACY_SETTINGS_DIALOG.MANAGE_SETTINGS_TITLE')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    sx: {
      color: 'info.main',
      fontSize: '1rem',
      fontWeight: 'normal'
    }
  }, i18n.t('PRIVACY_SETTINGS_DIALOG.MANAGE_SETTINGS_DESCRIPTION'))))), /*#__PURE__*/React.createElement(Box, {
    mt: 4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "end",
    sx: {
      color: 'info.main'
    },
    control: /*#__PURE__*/React.createElement(Checkbox, {
      sx: {
        width: '1.5rem',
        height: '1.5rem',
        padding: '0',
        margin: '9px'
      },
      icon: /*#__PURE__*/React.createElement(CheckBoxOutlineBlankSharpIcon, {
        sx: {
          backgroundColor: 'background.default',
          color: 'background.default'
        }
      }),
      checkedIcon: /*#__PURE__*/React.createElement(CheckSharpIcon, {
        sx: {
          backgroundColor: 'primary.main',
          color: 'white'
        }
      }),
      checked: marketingCookiesConsent,
      onChange: handleMarketingCookiesConsentChange
    }),
    label: i18n.t('CONSENT'),
    labelPlacement: "end"
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      paddingLeft: '33px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: '1rem',
      color: 'info.main'
    },
    variant: "body1",
    component: 'span'
  }, i18n.t('PRIVACY_SETTINGS_DIALOG.INFO')), "\xA0", /*#__PURE__*/React.createElement(Link, {
    underline: "hover",
    href: props.dataProtectionPolicy
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    sx: {
      color: 'primary.main',
      fontSize: '1rem',
      fontWeight: 'normal',
      display: 'inline-block'
    }
  }, i18n.t('READ_MORE')))), /*#__PURE__*/React.createElement(Grid, {
    mt: 3,
    container: true,
    alignItems: 'center',
    columnSpacing: 5,
    rowSpacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4,
    xl: 4
  }, /*#__PURE__*/React.createElement(Button, {
    sx: {
      textTransform: 'none',
      fontSize: '1rem',
      '&:hover': {
        boxShadow: 'none'
      }
    },
    color: "primary",
    fullWidth: true,
    disableElevation: true,
    variant: "contained",
    onClick: handleConsent
  }, i18n.t('SAVE'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: 8,
    lg: 8,
    xl: 8,
    sx: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    component: "span",
    sx: {
      fontSize: '0.75rem',
      color: 'info.main'
    }
  }, i18n.t('PRIVACY_SETTINGS_DIALOG.DATA_PROTCTION_LINK')), "\xA0", /*#__PURE__*/React.createElement(Link, {
    underline: "hover",
    href: props.dataProtectionPolicy
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    sx: {
      color: 'primary.main',
      fontSize: '0.75rem',
      fontWeight: 'normal',
      display: 'inline-block'
    }
  }, i18n.t('PRIVACY_SETTINGS_DIALOG.LINK'))), /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    sx: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    href: props.corporateInformation,
    underline: "hover"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    component: 'span',
    sx: {
      color: 'primary.main',
      fontSize: '0.75rem'
    }
  }, i18n.t('CORPORATE_INFORMATION')))))))));
};